import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as CurlyBracketsIcon } from './curlyBrackets.svg';

export const CurlyBrackets = IconHOC(CurlyBracketsIcon);
